const ContactNumberType = `
  id
  description
`;

export default ContactNumberType;
